"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_MedicinalProductPharmaceutical_WithdrawalPeriod = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Quantity_1 = require("./RTTI_Quantity");
var RTTI_Element_1 = require("./RTTI_Element");
exports.RTTI_MedicinalProductPharmaceutical_WithdrawalPeriod = t.recursion('IMedicinalProductPharmaceutical_WithdrawalPeriod', function () {
    return t.intersection([
        t.type({
            tissue: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            value: RTTI_Quantity_1.RTTI_Quantity
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            supportingInformation: t.string,
            _supportingInformation: RTTI_Element_1.RTTI_Element
        })
    ]);
});
//# sourceMappingURL=RTTI_MedicinalProductPharmaceutical_WithdrawalPeriod.js.map